import React from 'react';
import { DatePicker, Form, Input, Modal, Spin } from 'antd';
import { CLOSING_PACKAGE_MODAL_TITLES } from '../../workspace/closingPackageModalKinds';
import { DOCUMENT_UI_DATETIME_FORMAT } from '../../../../utils/documentUiFormat';
import { useFormationModal } from '../../hooks/useFormationModal';
import ClosingPackageCompositionEditor from '../ClosingPackageCompositionEditor';
import ClosingPackageTaskModalContext from './ClosingPackageTaskModalContext';
import ClosingPackageTaskModalEventDateHint from './ClosingPackageTaskModalEventDateHint';
import ClosingPackageTaskModalFooter from './ClosingPackageTaskModalFooter';
import type { ClosingPackageTaskModalBaseProps } from './ClosingPackageFormationModal.types';

export type ClosingPackageFormationModalProps = ClosingPackageTaskModalBaseProps & {
  onSuccess?: () => void | Promise<void>;
};

/**
 * IMP-001H-2A — FORM_CLOSING_PACKAGE workspace modal with Composition Editor + confirmFormation.
 */
const ClosingPackageFormationModal: React.FC<ClosingPackageFormationModalProps> = ({
  open,
  onClose,
  applicationId,
  onSuccess,
}) => {
  const { form, projection, contextView, contextLoading, submitting, handleSubmit } =
    useFormationModal({
      applicationId,
      open,
      onClose,
      onSuccess,
    });

  return (
    <Modal
      title={CLOSING_PACKAGE_MODAL_TITLES.formation}
      open={open}
      onCancel={onClose}
      destroyOnClose
      width="min(1440px, calc(100vw - 32px))"
      style={{ top: 16 }}
      styles={{ body: { maxHeight: 'calc(100vh - 150px)', overflowY: 'auto' } }}
      className="cp-task-modal"
      footer={
        <ClosingPackageTaskModalFooter
          onClose={onClose}
          onSubmit={handleSubmit}
          submitting={submitting}
          submitLabel="Сформировать комплект"
        />
      }
    >
      {contextLoading || !projection ? (
        <div style={{ textAlign: 'center', padding: 32 }}>
          <Spin />
        </div>
      ) : (
        <>
          <ClosingPackageTaskModalContext contextView={contextView} />

          <Form form={form} layout="vertical">
            <Form.Item
              name="formedAt"
              label="Дата формирования комплекта"
              rules={[{ required: true, message: 'Укажите дату формирования комплекта' }]}
            >
              <DatePicker showTime style={{ width: '100%' }} format={DOCUMENT_UI_DATETIME_FORMAT} />
            </Form.Item>

            <Form.Item label="Состав комплекта" required>
              <div
                className="cp-task-modal__composition-shell"
                data-testid="formation-modal-composition-editor"
              >
                <ClosingPackageCompositionEditor projection={projection} />
              </div>
            </Form.Item>

            <Form.Item
              name="comment"
              label="Комментарий формирования"
            >
              <Input.TextArea
                rows={3}
                maxLength={500}
                showCount
                placeholder="Комментарий для журнала комплекта (необязательно)"
              />
            </Form.Item>
          </Form>

          <ClosingPackageTaskModalEventDateHint />
        </>
      )}
    </Modal>
  );
};

export default ClosingPackageFormationModal;
